import getEstateImage from "@/domains/estate/helpers/getEstateImage";

type Props = {
  id: number;
};

export default function EstateFeeImage({ id }: Props) {
  return (
    <div
      className="relative isolate rounded-[0.875rem] h-[15rem] mb-5 shrink-0 overflow-clip"
      style={{
        backgroundImage: `url(${getEstateImage(id)})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
  );
}
